import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';
import { DocuSignForm } from '@trade-platform/ui-shared';

@Injectable()
export class OrderDocusignSendService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderDocusignSend(form: DocuSignForm): Observable<any> {
        return this.http.post<any>(`${this.environment.api}orders/${form.orderId}/send`, {
            emailSubject: form.emailSubject,
            emailBody: form.emailBody
        });
    }
}
